// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2RiFH","empty":"ModalGraph_empty__3eEPo"};